import {initBuffers} from "./init-buffers.js";
import {drawScene} from "./draw-scene.js";
import React, {useEffect, useRef, useState} from "react";

import vertexShaderSource from "./vertexShader.vert.js";
import fragmentShaderSource from "./fragmentShader.frag.js";

//var resolution = 70; //MAX 50 when all sides
//var gapsize = 0.005; //var gapsize = 0.001;
var sideamt = 1;
var skip = 100;

const Webgl = props => {
    const canvasRef = useRef(null)
    let initialized = useRef(false);
    let canvRef = useRef();
    let glRef= useRef()
    let buffersRef= useRef()
    let programInfoRef= useRef()
    let textureRef= useRef()
    let videoRef= useRef()
    // will set to true when video can be copied to texture
    let copyVideoRef = useRef(false)


    var res = props.tiles+1;
    var faces = res*res;


    const tex = document.createElement("canvas");
    const ctx = tex.getContext('2d', { willReadFrequently: true });

    let cubeRotation = 0.0;
    let deltaTime = 0;

    let playing = false;
    let timeupdate = false;

    let gl;
    let canvas;
    let programInfo;
    let buffers;
    let texture;
    let video;





    let then = 0;
    // Draw the scene repeatedly
    var count = 0;
    var dir = true;

    let ampsize = props.ampsize * 0.0001 - 0.005;
    let gapsize = props.gapsize * 0.0001;
    let enableBG = props.bg;

    var reqID;
        function render(now) {
        /*count += 1;
        if( count > 50){
          count = 0;
          if(dir){
              resolution+=1;
              if(resolution >= 10){ dir = !dir; }
          }else{
              resolution-=1;
              if(resolution <= 1){ dir = !dir; }
          }

          buffers = initBuffers(gl, resolution, gapsize);
        }*/

        now *= 0.001; // convert to seconds
        deltaTime = now - then;
        then = now;

        //gapsize += 0.00001;

        //console.log("COPY",copyVideoRef.current);

        if (copyVideoRef.current) {
            //console.log("Update Textures");
            updateTexture(gl, texture, video);
            if(updateAverages(video)) {
                buffers.position = initBuffers(gl, res, gapsize, ampsize, enableBG, sideamt, averages);
            }else{
                //console.log("Idle Re-Init", "AMP SIZE:", ampsize);
                //buffers = initBuffers(gl, resolution, gapsize, ampsize, sideamt);
            }
        }else{

        }

        drawScene(gl, programInfo, buffers, texture, cubeRotation, res, enableBG, sideamt, averages);
        //cubeRotation += deltaTime * 0.1;

        //console.log("BLAAA");
        reqID = requestAnimationFrame(render);  // DONT CALL IT
    }


    useEffect(() => {
        function initAll(){
            canvas = canvRef.current || canvasRef.current;
            // Initialize the GL context
            gl = glRef.current || canvas.getContext("webgl2");

            // Only continue if WebGL is available and working
            if (gl === null) {
                alert("Unable to initialize WebGL. Your browser or machine may not support it.");
                return;
            }

            // Set clear color to black, fully opaque
            gl.clearColor(0.0, 0.0, 0.0, 1.0);
            // Clear the color buffer with specified clear color
            gl.clear(gl.COLOR_BUFFER_BIT);

            // Vertex shader program
            const vsSource = vertexShaderSource;
            // Fragment shader program
            const fsSource = fragmentShaderSource;

            // Initialize a shader program; this is where all the lighting
            // for the vertices and so forth is established.
            const shaderProgram = initShaderProgram(gl, vsSource, fsSource);

            // Collect all the info needed to use the shader program.
            // Look up which attributes our shader program is using
            // for aVertexPosition, aVertexColor and also
            // look up uniform locations.
            programInfo = programInfoRef.current || {
                program: shaderProgram,
                attribLocations: {
                    vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
                    vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
                    textureCoord: gl.getAttribLocation(shaderProgram, "aTextureCoord"),
                },
                uniformLocations: {
                    projectionMatrix: gl.getUniformLocation(
                        shaderProgram,
                        "uProjectionMatrix"
                    ),
                    modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
                    normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
                    uSampler: gl.getUniformLocation(shaderProgram, "uSampler"),
                    textureSizeLocation: gl.getUniformLocation(shaderProgram, "uTextureSize"),
                },
            };

            // Here's where we call the routine that builds all the
            // objects we'll be drawing.
            let ampsize = props.ampsize * 0.0001 - 0.005;
            buffers = buffersRef.current || initBuffers(gl, res, gapsize, ampsize, enableBG, sideamt);
            //if(!textureLoaded) {
            texture = textureRef.current || initTexture(gl);
            //    setTextureLoaded(true);
            //}
            video = videoRef.current || setupVideo();

            // Flip image pixels into the bottom-to-top order that WebGL expects.
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        }

        /*if(!initialized.current){
            console.log("INIT WebGL");
            initAll();
            initialized.current = true;
        }*/
        initAll();

        requestAnimationFrame(render);

        // Cleanup: Stop the render loop when the component unmounts
        return () => {
            //deleteAll();
            cancelAnimationFrame(reqID);
        };

    }, [props.gapsize, props.ampsize, props.tiles, props.bg]);

        function deleteAll(){
            var gl = glRef.current;

            if(gl == null){ return; }

            console.log("DELETE RESSOURCES");
            var numTextureUnits = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
            for (var unit = 0; unit < numTextureUnits; ++unit) {
                gl.activeTexture(gl.TEXTURE0 + unit);
                gl.bindTexture(gl.TEXTURE_2D, null);
                gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, null);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
            gl.bindRenderbuffer(gl.RENDERBUFFER, null);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);

            gl.deleteTexture(textureRef.current);
            gl.deleteBuffer(buffersRef.current.position);
            gl.deleteBuffer(buffersRef.current.normal);
            gl.deleteBuffer(buffersRef.current.textureCoord);
            gl.deleteBuffer(buffersRef.current.indices);

            /*initialized.current = false;

            glRef.current = null;
            programInfoRef.current = null;
            buffersRef.current = null;
            textureRef.current = null;
            videoRef.current = null;*/
        }


    var averages = [];

    var l = 0.2;
    var r = 0.8;
    var t = 0.8;
    var b = 0.2;
    var texQuadsize = (r - l) / res;
    var texOrigin = {x: l, y: b}

    function getTexCoords(x, y) {
        var pixelorigin = {
            x: texOrigin.x + (x * texQuadsize) + (texQuadsize / 2),
            y: texOrigin.y + (y * texQuadsize) + (texQuadsize / 2),
        }

        return {
            l: pixelorigin.x - texQuadsize / 2,
            b: pixelorigin.y - texQuadsize / 2,
            r: pixelorigin.x + texQuadsize / 2,
            t: pixelorigin.y + texQuadsize / 2,
        }
    }

    function updateAverages(video) {
        tex.width = video.videoWidth;
        tex.height = video.videoHeight;
        if(tex.width == 0 || tex.height == 0){ return false; }
        ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

        var av = [];
        for (var a = 0; a < faces; a++) {
            var tex_i = a % res;
            var tex_j = Math.floor(a / res);
            var textxy = getTexCoords(tex_i, tex_j);

            var l = textxy.l * video.videoWidth;
            var r = textxy.r * video.videoWidth;
            var t = textxy.t * video.videoHeight;
            var b = textxy.b * video.videoHeight;


            var rgb = getAverage(
                l,
                (video.videoHeight - 1) - t,
                r - l,
                t - b
            ); //TOP is bottom and BOTTOM is top
            av.push(rgb);
        }
        averages = av;
        return true;
    }



    function getAverage(regionX, regionY, regionWidth, regionHeight){
        const imageData = ctx.getImageData(regionX, regionY, regionWidth, regionHeight);
        const data = imageData.data; // Array of pixel values (RGBA)

        let totalR = 0;
        let totalG = 0;
        let totalB = 0;
        const pixelCount = data.length / (4 * skip); // Number of pixels (each pixel is 4 array elements)

        for (let i = 0; i < data.length; i += 4 * skip) {
            totalR += data[i + 0];
            totalG += data[i + 1];
            totalB += data[i + 2];
        }

        const avgR = totalR / pixelCount;
        const avgG = totalG / pixelCount;
        const avgB = totalB / pixelCount;

        return {avgR, avgG, avgB}
    }


//
// Initialize a shader program, so WebGL knows how to draw our data
//
    function initShaderProgram(gl, vsSource, fsSource) {
        const vertexShader = loadShader(gl, gl.VERTEX_SHADER, vsSource);
        const fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fsSource);

        // Create the shader program

        const shaderProgram = gl.createProgram();
        gl.attachShader(shaderProgram, vertexShader);
        gl.attachShader(shaderProgram, fragmentShader);
        gl.linkProgram(shaderProgram);

        // If creating the shader program failed, alert

        if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
            alert(
                `Unable to initialize the shader program: ${gl.getProgramInfoLog(
                    shaderProgram
                )}`
            );
            return null;
        }

        return shaderProgram;
    }

//
// creates a shader of the given type, uploads the source and
// compiles it.
//
    function loadShader(gl, type, source) {
        const shader = gl.createShader(type);

        // Send the source to the shader object

        gl.shaderSource(shader, source);

        // Compile the shader program

        gl.compileShader(shader);

        // See if it compiled successfully

        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            alert(
                `An error occurred compiling the shaders: ${gl.getShaderInfoLog(shader)}`
            );
            gl.deleteShader(shader);
            return null;
        }

        return shader;
    }

    function initTexture(gl) {
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);

        // Because video has to be download over the internet
        // they might take a moment until it's ready so
        // put a single pixel in the texture so we can
        // use it immediately.
        const level = 0;
        const internalFormat = gl.RGBA;
        const width = 1;
        const height = 1;
        const border = 0;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        const pixel = new Uint8Array([0, 100, 255, 255]); // opaque blue
        gl.texImage2D(
            gl.TEXTURE_2D,
            level,
            internalFormat,
            width,
            height,
            border,
            srcFormat,
            srcType,
            pixel
        );

        // Generate mipmaps
        //  gl.generateMipmap(gl.TEXTURE_2D);

        // Turn off mips and set wrapping to clamp to edge so it
        // will work regardless of the dimensions of the video.
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);

        return texture;
    }

    function updateTexture(gl, texture, video) {
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(
            gl.TEXTURE_2D,
            level,
            internalFormat,
            srcFormat,
            srcType,
            video
        );
    }

    function setupVideo() {
        //const video = document.createElement("video");
        const video = props.capref.current;

        video.playsInline = true;
        video.muted = true;
        video.loop = true;
        video.autoplay = true;

        // Waiting for these 2 events ensures
        // there is data in the video

        video.addEventListener(
            "playing",
            () => {
                playing = true;
                checkReady();
            },
            true
        );

        video.addEventListener(
            "timeupdate",
            () => {
                timeupdate = true;
                checkReady();
            },
            true
        );


        function checkReady() {
            if (playing && timeupdate) {
                copyVideoRef.current = true;
            }
        }

        return video;
    }



    return (
    <canvas
      ref={canvasRef}
      {...props}
      width={"1600"}
      height={"1200"}
      style={{width: "100%"}}
    />
  )

}

export default Webgl;